import LOG from '../logging/Logger'

export function processLargeArrayAsync(
  jobDescription,
  array,
  callbackFunction,
  callbackCompleteFunction,
  waitForAsync = false,
  maxTimePerChunk
) {
  const theMaxTimePerChunk = maxTimePerChunk || 16
  let index = 0
  let startTime = now()

  function now() {
    return new Date().getTime()
  }

  function doLog(str) {
    LOG.debug(`ProcessLargeArrayAsync (${jobDescription}, ${index}): ${str}`)
  }

  function doUnit() {
    const time = now() - startTime
    doLog('Processing time: ' + time)

    if (time <= theMaxTimePerChunk) {
      doLog('Continue processing')
      doWork()
    } else {
      doLog('Schedule processing')
      startTime = now()
      setTimeout(doWork, 1)
    }
  }

  function doWork() {
    doLog('doChunk')

    if (array && index < array.length) {
      doLog('Do callback')

      const answer = callbackFunction(array[index])

      if (waitForAsync && answer instanceof Promise) {
        doLog('Waiting for async')

        answer.then(() => {
          doLog('Async callback complete, move on')
          index++
          doUnit()
        })
      } else {
        index++
        doUnit()
      }
    } else if (callbackCompleteFunction) {
      doLog('Processing complete, call finished function')
      callbackCompleteFunction()
    }
  }

  doWork()
}
